import React from 'react';
import PropTypes from 'prop-types';

// Components
import MediaPictures from '../../../Common/MediaPictures/MediaPictures';

function Medias({ formik }) {
  return (
    <div>
      <MediaPictures formik={formik} withSlider />
    </div>
  );
}

Medias.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      videoUrl: PropTypes.string,
    }),
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    errors: PropTypes.shape({
      videoUrl: PropTypes.string,
    }),
    touched: PropTypes.shape({
      videoUrl: PropTypes.bool,
    }),
  }).isRequired,
};

export default Medias;
